var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import styles from './sds-file-upload-item.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
import { property } from 'lit/decorators.js';
import { getDictionary } from '@synisys/dictionary';
import { when } from 'lit/directives/when.js';
/**
 * Control represents a file uploaded item
 *
 */
let SdsFileUploadItem = (() => {
    var _SdsFileUploadItem_fileInfo_accessor_storage, _SdsFileUploadItem_maxFileSize_accessor_storage, _SdsFileUploadItem_fileProgress_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-file-upload-item')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _fileInfo_decorators;
    let _fileInfo_initializers = [];
    let _fileInfo_extraInitializers = [];
    let _maxFileSize_decorators;
    let _maxFileSize_initializers = [];
    let _maxFileSize_extraInitializers = [];
    let _fileProgress_decorators;
    let _fileProgress_initializers = [];
    let _fileProgress_extraInitializers = [];
    var SdsFileUploadItem = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsFileUploadItem_fileInfo_accessor_storage.set(this, __runInitializers(this, _fileInfo_initializers, void 0));
            _SdsFileUploadItem_maxFileSize_accessor_storage.set(this, (__runInitializers(this, _fileInfo_extraInitializers), __runInitializers(this, _maxFileSize_initializers, 1024)));
            _SdsFileUploadItem_fileProgress_accessor_storage.set(this, (__runInitializers(this, _maxFileSize_extraInitializers), __runInitializers(this, _fileProgress_initializers, void 0)));
            this.fileThumbnailUrl = __runInitializers(this, _fileProgress_extraInitializers);
        }
        /**
         * Represents the metadata for a single uploaded file.
         *
         * This property holds an instance of `FileInfo`, which provides information about the file
         * displayed by this component. It is marked with the `@property` decorator to enable
         * two-way data binding and make the property reactive within the LitElement lifecycle.
         *
         * The `FileInfo` object typically includes:
         * - `file`: A `File` object containing the uploaded file data (e.g., name, size, type).
         * - `isValid`: A boolean indicating whether the file passed all validation checks.
         * - `validationMessageKeys`: An array of validation message keys for error handling and localization.
         *
         * Key usages in this component:
         * - Displaying the file's name and size.
         * - Triggering the deletion of the file when the user clicks the delete button.
         * - Managing error states and progress information for the file upload process.
         *
         * This property is expected to be set externally when the `sds-file-upload-item` component
         * is used within the `sds-file-upload` parent component.
         *
         * Note: This property is public and can be modified dynamically, but care must be taken to
         * ensure the provided value is of the correct type.
         */
        get fileInfo() { return __classPrivateFieldGet(this, _SdsFileUploadItem_fileInfo_accessor_storage, "f"); }
        set fileInfo(value) { __classPrivateFieldSet(this, _SdsFileUploadItem_fileInfo_accessor_storage, value, "f"); }
        /**
         * Maximum file size allowed per file in KB.
         * Default value is set to 1024 KB (1 MB).
         */
        get maxFileSize() { return __classPrivateFieldGet(this, _SdsFileUploadItem_maxFileSize_accessor_storage, "f"); }
        set maxFileSize(value) { __classPrivateFieldSet(this, _SdsFileUploadItem_maxFileSize_accessor_storage, value, "f"); }
        get fileProgress() { return __classPrivateFieldGet(this, _SdsFileUploadItem_fileProgress_accessor_storage, "f"); }
        set fileProgress(value) { __classPrivateFieldSet(this, _SdsFileUploadItem_fileProgress_accessor_storage, value, "f"); }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (this.fileInfo && this.fileInfo.file.type.startsWith('image')) {
                const reader = new FileReader();
                reader.onload = () => {
                    this.fileThumbnailUrl = reader.result;
                    this.requestUpdate();
                };
                reader.readAsDataURL(this.fileInfo.file);
            }
        }
        render() {
            var _a, _b, _c, _d;
            return html ` <div class="${this._getClasses()}">
                <div class="sds-file-upload-item__thumb">
                    ${this.fileThumbnailUrl
                ? html `<img
                              width="48"
                              height="48"
                              src="${this.fileThumbnailUrl}"
                              alt="file thumbnail"
                              aria-hidden="true"
                          />`
                : this._getFileIconName()
                    ? html ` <sds-file-icon
                              size="24"
                              name="${this._getFileIconName()}"
                              aria-hidden="true"
                          ></sds-file-icon>`
                    : html `<span aria-hidden="true">?</span>`}
                </div>
                <div class="sds-file-upload-item__content">
                    <div class="sds-file-upload-item__name">
                        <sds-clipped-text text="${(_a = this.fileInfo) === null || _a === void 0 ? void 0 : _a.file.name}"></sds-clipped-text>
                    </div>
                    <div class="sds-file-upload-item__size">
                        ${this._formatFileSize(this.fileInfo.file)}
                    </div>
                    ${when(!((_b = this === null || this === void 0 ? void 0 : this.fileProgress) === null || _b === void 0 ? void 0 : _b.done), () => {
                var _a, _b;
                return html `
                            <sds-progress-bar
                                size="sm"
                                percent="${this.fileProgress ? (_a = this.fileProgress) === null || _a === void 0 ? void 0 : _a.percent : 0}%"
                                ?error="${!((_b = this.fileInfo) === null || _b === void 0 ? void 0 : _b.isValid)}"
                                aria-hidden="true"
                            ></sds-progress-bar>
                        `;
            }, () => html `
                            <div
                                class="sds-file-upload-item__uploaded-status"
                                role="status"
                                aria-live="polite"
                                aria-atomic="true"
                            >
                                ${getDictionary().translate('sds.file_upload.uploaded_successfully')}
                            </div>
                        `)}
                </div>

                <sds-button
                    type="tertiary"
                    size="md"
                    icon="delete"
                    @click="${() => this._handleDelete()}"
                    ?error="${!((_c = this.fileInfo) === null || _c === void 0 ? void 0 : _c.isValid)}"
                    role="group"
                    aria-label="Delete ${(_d = this.fileInfo) === null || _d === void 0 ? void 0 : _d.file.name}"
                ></sds-button>
            </div>
            ${this._renderErrors()}`;
        }
        _getClasses() {
            return classMap({
                'sds-file-upload-item': true,
                'sds-file-upload-item--uploaded': !!this.fileProgress && this.fileProgress.done,
                'sds-file-upload-item--has-error': !this.fileInfo.isValid,
            });
        }
        _handleDelete() {
            var _a;
            this.dispatchEvent(new CustomEvent(SdsFileUploadItem.DELETE_FILE_EVENT, {
                detail: {
                    file: (_a = this.fileInfo) === null || _a === void 0 ? void 0 : _a.file,
                },
            }));
        }
        _formatFileSize(file) {
            if (file.size < 1024) {
                return `${file.size}B`;
            }
            if (file.size < 1024 * 1024) {
                return `${(file.size / 1024).toFixed(2)}KB`;
            }
            if (file.size < 1024 * 1024 * 1024) {
                return `${(file.size / 1024 / 1024).toFixed(2)}MB`;
            }
            return `${(file.size / 1024 / 1024 / 1024).toFixed(2)}GB`;
        }
        _renderErrors() {
            var _a;
            return html ` ${when(!((_a = this.fileInfo) === null || _a === void 0 ? void 0 : _a.isValid), () => html ` <sds-error
                role="status"
                aria-live="polite"
                aria-atomic="true"
                message="${getDictionary()
                .translate('sds.file_upload.file_max_size_validation')
                .replace('%s', `${this.maxFileSize}`)}"
            ></sds-error>`, () => nothing)}`;
        }
        _getFileIconName() {
            if (this.fileInfo) {
                const fileType = this.fileInfo.file.type.toLowerCase();
                if (fileType.includes('pdf')) {
                    return 'pdf';
                }
                if (fileType.includes('word')) {
                    return 'microsoft_word';
                }
                if (fileType.includes('excel') ||
                    fileType.includes('xlsx') ||
                    fileType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
                    return 'microsoft_excel';
                }
            }
            return null;
        }
    };
    _SdsFileUploadItem_fileInfo_accessor_storage = new WeakMap();
    _SdsFileUploadItem_maxFileSize_accessor_storage = new WeakMap();
    _SdsFileUploadItem_fileProgress_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsFileUploadItem");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _fileInfo_decorators = [property({ type: Object })];
        _maxFileSize_decorators = [property({ type: Number, attribute: 'max-file-size' })];
        _fileProgress_decorators = [property({ type: Object })];
        __esDecorate(_classThis, null, _fileInfo_decorators, { kind: "accessor", name: "fileInfo", static: false, private: false, access: { has: obj => "fileInfo" in obj, get: obj => obj.fileInfo, set: (obj, value) => { obj.fileInfo = value; } }, metadata: _metadata }, _fileInfo_initializers, _fileInfo_extraInitializers);
        __esDecorate(_classThis, null, _maxFileSize_decorators, { kind: "accessor", name: "maxFileSize", static: false, private: false, access: { has: obj => "maxFileSize" in obj, get: obj => obj.maxFileSize, set: (obj, value) => { obj.maxFileSize = value; } }, metadata: _metadata }, _maxFileSize_initializers, _maxFileSize_extraInitializers);
        __esDecorate(_classThis, null, _fileProgress_decorators, { kind: "accessor", name: "fileProgress", static: false, private: false, access: { has: obj => "fileProgress" in obj, get: obj => obj.fileProgress, set: (obj, value) => { obj.fileProgress = value; } }, metadata: _metadata }, _fileProgress_initializers, _fileProgress_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsFileUploadItem = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.DELETE_FILE_EVENT = 'sds.upload.file.delete';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsFileUploadItem = _classThis;
})();
export { SdsFileUploadItem };
